import AdvancedSearchContainer from "./AdvancedSearchContainer";

export default AdvancedSearchContainer;
